<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.activity_show,
                    },
                    {
                        name: $t('messages.assign_evaluation_value'),
                        href: null,
                    },
                ]"
            />
        </template>

        <SubactivitiesGrade
            :students="students"
            :group-id="group.id"
            :ranges="ranges"
            :url="meta.links.update"
            @decimalScores="updateDecimalScores"
            :can-edit="meta.can.edit_grades"
        />

        <ActivityGradesSummary :values="decimalScores" :ranges="ranges" />

        <ActivityGradeResponsesGraphs
            :bar-chart-options="graphs.barChartOptions"
            :line-chart-options="graphs.lineChartOptions"
            :values="decimalScores"
            :ranges="ranges"
        />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubactivitiesGrade from '@/components/pageSpecific/SubactivitiesGrade.vue';
import ActivityGradeResponsesGraphs from '@/components/pageSpecific/ActivityGradeResponsesGraphs.vue';
import ActivityGradesSummary from '@/components/pageSpecific/ActivityGradesSummary.vue';

export default {
    components: {
        SubactivitiesGrade,
        ActivityGradeResponsesGraphs,
        ActivityGradesSummary,
        PanelPage,
    },
    data() {
        return {
            decimalScores: [],
        };
    },
    props: ['activity', 'meta', 'options', 'students', 'ranges', 'graphs', 'group'],
    name: 'Edit',
    layout: Layout,
    methods: {
        updateDecimalScores(values) {
            this.decimalScores = values;
        },
    },
};
</script>
